import * as React from 'react';
const MessageSentIcon = () => (
  <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.50006 8.10016L2.75006 6.35016C2.55506 6.15516 2.24506 6.15516 2.05006 6.35016C1.85506 6.54516 1.85506 6.85516 2.05006 7.05016L4.14506 9.14516C4.34006 9.34016 4.65506 9.34016 4.85006 9.14516L10.1501 3.85016C10.3451 3.65516 10.3451 3.34516 10.1501 3.15016C9.95506 2.95516 9.64506 2.95516 9.45006 3.15016L4.50006 8.10016Z"
      fill="#969696"
    />
  </svg>
);
export default MessageSentIcon;
